import {Button} from '@vector';
import {ArrowRightBoldIcon} from '@solar-icons/react';
import HeroWidgets from './HeroWidgets';
import styles from './Hero.module.css';

const HOTMATHS_WORDMARK_URL = '/assets/branding/home/hotmaths-logo-aligned-accessible-orange.svg';
const CAMBRIDGE_LOGO_URL = '/assets/branding/checkpoints/cambridge-logo-text.svg';

/**
 * The page's opening statement, split into a first line and a last word (e.g. "Cambridge" / "HOTmaths"),
 * shown as the Cambridge text logo above the HOTmaths wordmark - presentational only, `content.intro.heading`
 * itself is untouched and supplies the images' alt text.
 */
function splitHeading(heading) {
    const words = heading.trim().split(' ');
    const highlight = words.pop();
    return {lead: words.join(' '), highlight};
}

/**
 * `logo` is the brand's own (`content.logo`, e.g. Cambridge LANTITE Edge): one image standing for the whole heading in
 * place of the Cambridge-over-HOTmaths pair. A white one made for dark backgrounds is drawn black.
 */
export default function Hero({content, logo}) {
    const {lead, highlight} = splitHeading(content.heading);

    // The brand's banner image, if it has one, under its theme's overlay (Hero.module.css).
    const backgroundStyle = content.backgroundImage
        ? {'--home-hero-image': `url("${content.backgroundImage}")`}
        : undefined;

    return (
        <section className={styles.hero} style={backgroundStyle}>
            <div className={styles.inner}>
                <div className={styles.text}>
                    <h1 className={styles.heading}>
                        {logo && (
                            <img className={`${styles.brandLogo} ${logo.onDark ? styles.brandLogoOnDark : ''}`}
                                 src={logo.src} alt={content.heading}/>
                        )}
                        {!logo && lead && (
                            <span className={styles.highlight}>
                                <img className={styles.highlightLogo} src={CAMBRIDGE_LOGO_URL} alt={lead}/>
                            </span>
                        )}
                        {!logo && (
                            <span className={styles.headingLine}>
                                <img className={styles.headingLogo} src={HOTMATHS_WORDMARK_URL} alt={highlight}/>
                            </span>
                        )}
                        {content.edition && <span className={styles.edition}>{content.edition}</span>}
                    </h1>
                    <p className={styles.standfirst}>{content.standfirst}</p>
                    <div className={styles.actions}>
                        <Button surface="accent" size="large" href={content.primaryAction.href}
                                icon={<ArrowRightBoldIcon size={20}/>} iconPosition="end">
                            {content.primaryAction.label}
                        </Button>
                        <Button size="large" href={content.secondaryAction.href}>
                            {content.secondaryAction.label}
                        </Button>
                    </div>
                </div>

                <div className={styles.visualWrap}>
                    <HeroWidgets/>
                </div>
            </div>
        </section>
    );
}
